// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__eN0WC","leftside":"footer_leftside__J2y0a","wrapper":"footer_wrapper__pR1E3","element":"footer_element__ncVLe","rightside":"footer_rightside__rmJPR"};